import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MonthlyInvoice } from 'src/app/models/monthlyinvoice.model';
import { ShortCodesService } from 'src/app/services/shortcodes.service';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { ConfirmationService, LazyLoadEvent } from 'primeng/api';
import { BadgeService } from 'src/app/services/badge.service';
import { BadgeData } from 'src/app/models/badge.model';
import { Table, TableRowExpandEvent } from 'primeng/table';
@Component({
  selector: 'app-monthly-billing',
  templateUrl: './monthly-billing.component.html',
  styleUrls: ['./monthly-billing.component.scss']
})
export class MonthlyBillingComponent extends ScrBaseComponent implements OnInit {

  monthlyInvoiceList!: MonthlyInvoice[];
  tempStorageList!: MonthlyInvoice[];
  totalRecordStorage!: number;
  public invoiceLines = new Map<number, object>();

  isDisplayReady = false;
  currentPage = 0;
  totalRecords = 0;
  searchValue?: number;
  isSearchError = false;

  @ViewChild('tt', { static: false }) tt!: Table;

  invoiceColumns: { field: string, header: string, width: number, sorting: boolean }[] = [
    { field: 'monthlyInvoiceId', header: 'Invoice ID', width: 11, sorting: true },
    { field: 'invoiceStatus', header: 'Invoice Status', width: 14, sorting: true },
    { field: 'numberOfCodes', header: 'Short Codes', width: 11, sorting: true },
    { field: 'totalPrice', header: 'Total Price', width: 11, sorting: true },
    { field: 'invoiceDate', header: 'Invoice Date', width: 11, sorting: true },
    { field: 'paymentDueDate', header: 'Due Date', width: 11, sorting: true },
    { field: 'paymentReceivedDate', header: 'Paid Date', width: 11, sorting: true },
    { field: 'paymentMethod', header: 'Payment Method', width: 11, sorting: true },
    { field: 'action', header: 'Action', width: 11, sorting: false }
  ];
  expandedInvoiceColumns: { header: string, width: number, sorting: boolean }[] = [
    { header: 'Short Code', width: 8, sorting: false },
    { header: 'Start Date', width: 14, sorting: false },
    { header: 'End Date', width: 14, sorting: false },
    { header: 'Type', width: 11, sorting: false },
    { header: 'Price', width: 12, sorting: false },
    { header: 'Lease Order', width: 12, sorting: false },
    { header: 'Lease End', width: 12, sorting: false },
    { header: 'Lease Month', width: 8, sorting: false }
  ];
  constructor(private shortCodesService: ShortCodesService,
    private router: Router,
    private badgeService: BadgeService,
    private confirmationService: ConfirmationService) { super(); }

  ngOnInit(): void {
    this.observe(this.shortCodesService.getMonthlyInvoiceList("1", "5", "1", this.searchValue), rsp => {
      this.isDisplayReady = true;
      this.tempStorageList = rsp.data.invoices;
      this.monthlyInvoiceList = rsp.data.invoices;
      this.totalRecords = rsp.data.totalCount;
      this.totalRecordStorage = this.totalRecords;
      if (this.tt) {
        this.tt.saveState();
      }

      if (rsp.data?.unpaidCount !== undefined) {
        this.badgeService.updateLocally((data: BadgeData) => {
          if (data.monthlyInvoiceCount !== rsp.data.unpaidCount) {
            const previous = data.monthlyInvoiceCount;
            data.monthlyInvoiceCount = rsp.data.unpaidCount;
            this.log.debug('monthly invoice count updated from ' + previous + ' to ' + data.transfersCount);
            return data;
          }
          return undefined;
        });
      }


      return false; // don't display success.
    });
  }

  loadLazyInvoiceLoad(event: LazyLoadEvent) {
    this.tt.expandedRowKeys = {};
    this.currentPage = (event.first ?? 0) / (event.rows ?? 0) + 1;
    this.observe(this.shortCodesService.getMonthlyInvoiceList(this.currentPage.toString(), "5", "1", undefined), rsp => {
      this.isDisplayReady = true;
      this.monthlyInvoiceList = rsp.data.invoices;
      this.totalRecords = rsp.data.totalCount;
      this.totalRecordStorage = this.totalRecords;
      if (rsp.data?.unpaidCount) {
        this.badgeService.updateLocally((data: BadgeData) => {
          if (data.monthlyInvoiceCount !== rsp.data.unpaidCount) {
            const previous = data.monthlyInvoiceCount;
            data.monthlyInvoiceCount = rsp.data.unpaidCount;
            this.log.debug('monthly invoice count updated from ' + previous + ' to ' + data.transfersCount);
            return data;
          }
          return undefined;
        });
      }

      return false; // don't display success.

    });


  }

  searchInvoice() {
    this.isSearchError = false;
    if (this.searchValue && this.searchValue.toString().length < 7) {
      this.isSearchError = true;
      return;
    }
    this.tempStorageList = this.monthlyInvoiceList;
    this.observe(this.shortCodesService.getMonthlyInvoiceList("1", "5", "1", this.searchValue), rsp => {
      this.clearMessages();
      this.isDisplayReady = true;
      this.monthlyInvoiceList = rsp.data.invoices;
      this.totalRecords = 1;
      this.tt.saveState();

      return false; // don't display success.
    });
  }

  expansionShowHide(invoiceID: number) {
    this.monthlyInvoiceList.forEach(mi => {
      if (mi.monthlyInvoiceId == invoiceID) {
        if (mi.lines === undefined ||
          (mi.lines && mi.lines.length == 0)) {
          this.loadInvoice(invoiceID);
        }
        mi.isExpansionDisplay = true;
      }
    });
  }

  maybeGoToOrderHistory(scId: number) {
    this.confirmationService.confirm({
      message: `<p>Would you like to see the order history for short code ${scId}?</p>`,
      header: `Navigate to ${scId} history?`,
      key: 'shortCodeHistoryNavigation',
      accept: () => {
        this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['billing', { outlets: { 'billing-tab': ['view-orders'] } }] } }], { state: { scId, needBackend: true } });
      }
    });
  }

  viewShortCode(scId: number) {
    this.observe(this.shortCodesService.getLeasedCodeDetail(scId), {
      onSuccess: (rsp) => {
        if (rsp.results && rsp.results.length > 0) {
          this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['shortcode-list'] } }] } }], { state: { scId } });
        }
        else {
          this.maybeGoToOrderHistory(scId);
        }
        return false;
      },
      onError: res => {
        if (res.status === 404) {
          this.maybeGoToOrderHistory(scId);
          return false;
        }
        else {
          // Give error message if not 404.
          return true;
        }
      }
    });
  }

  viewReceipt(monthlyInvoiceId: string) {
    this.router.navigate([
      '/dashboard',
      { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['receipt', monthlyInvoiceId] } }] } }
    ]);

    window.scrollTo(0, 0);
  }

  viewInvoice(orderId: string) {
    this.router.navigate([
      '/dashboard',
      { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['invoice', orderId] } }] } }
    ]);

    window.scrollTo(0, 0);
  }


  loadInvoice(invoiceID: number) {
    this.observe(this.shortCodesService.getMonthlyInvoiceDetail(invoiceID), rsp => {
      for (let i = 0; i < this.monthlyInvoiceList.length; i++) {
        if (this.monthlyInvoiceList[i].monthlyInvoiceId == invoiceID) {
          this.monthlyInvoiceList[i] = rsp.data?.invoices[0];
          this.invoiceLines.set(invoiceID, this.monthlyInvoiceList[i].lines);
          this.isDisplayReady = true;
          this.monthlyInvoiceList[i].isExpansionDisplay = true;
          const e: TableRowExpandEvent = { data: this.monthlyInvoiceList[i], originalEvent: new Event('click') };
          this.tt.onRowExpand.emit(e);
          return false;
        }
      }
      return false;
    });
  }

  clearSearch() {
    this.searchValue = undefined;
    this.monthlyInvoiceList = this.tempStorageList;
    this.totalRecords = this.totalRecordStorage;
    this.tt.restoreState();
  }


  navigateByLeaseOrderId(orderId: number, scId: number) {
    this.observe(this.shortCodesService.getLeasedCodeDetail(scId), {
      onSuccess: () => {
        this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['shortcode-list'] } }] } }], { state: { orderId } });
      },
      onError: () => {
        this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['billing', { outlets: { 'billing-tab': ['view-orders'] } }] } }], { state: { orderId, needBackend: true } });
      }
    });
  }

}
